var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.08045L3.54167 0.5C3.38542 0.416667 3.20833 0.375 3.04167 0.375C2.875 0.375 2.70833 0.416667 2.55208 0.5C2.39583 0.583333 2.26042 0.708333 2.15625 0.864583C2.05208 1.02083 2 1.19792 2 1.375V15.625C2 15.8021 2.05208 15.9792 2.15625 16.1354C2.26042 16.2917 2.39583 16.4167 2.55208 16.5C2.70833 16.5833 2.875 16.625 3.04167 16.625C3.20833 16.625 3.38542 16.5833 3.54167 16.5L14.1667 9.91954C14.3229 9.83621 14.4583 9.71121 14.5625 9.55504C14.6667 9.39888 14.7188 9.22179 14.7188 9.04467C14.7188 8.86755 14.6667 8.69046 14.5625 8.53429C14.4583 8.37813 14.3229 8.25313 14.1667 8.16979V7.08045Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.61b2ab1c463bd46a6f1148a2f1fbc29d.svg";
export { ForwardRef as ReactComponent };